import React, { useEffect, useState } from 'react';
import { getAdminPlayback, setAdminPlayback, prepareAdminPlayback, getAdminPlaybackAnchors } from '../api';

// Organiser controls appear only when the server's race gate permits them.
export default function PubSyncControls({ raceId, completed = false }) {
  const [state, setState] = useState(null);
  const [message, setMessage] = useState('');
  const [pending, setPending] = useState(false);
  const [anchors, setAnchors] = useState(null);
  useEffect(() => {
    let closed = false;
    setState(null);
    const refresh = () => getAdminPlayback(raceId).then(v => { if (!closed) setState(v); }).catch(() => {});
    refresh(); const timer = setInterval(refresh, 6000);
    getAdminPlaybackAnchors(raceId).then(v => { if (!closed) setAnchors(v); }).catch(() => {});
    return () => { closed = true; clearInterval(timer); };
  }, [raceId]);
  if (!state) return null;
  const settings = state.settings;
  const change = async (delayMs, enabled, action = 'manual') => {
    setPending(true); setMessage('');
    try {
      const result = await setAdminPlayback(raceId, { delayMs, enabled, expectedVersion: settings.version, action });
      setState(previous => ({ ...previous, settings: result.value,
        calibration: { ...previous.calibration, ...result.calibration } }));
      if (!enabled) setMessage('TV sync is off. Following screens return to Live within five seconds; no Render change or reload needed.');
    } catch (e) {
      if (e.response?.status === 409) {
        const fresh = await getAdminPlayback(raceId).catch(() => null);
        if (fresh) setState(fresh);
        setMessage('Settings changed elsewhere. Updated; please retry.');
      } else setMessage(e.response?.data?.error || e.message);
    } finally { setPending(false); }
  };
  const prepare = async () => {
    setPending(true); try {
      const result = await prepareAdminPlayback(raceId);
      setMessage(result.ok ? 'Preparation active for three minutes.' : 'Preparation unavailable.');
    } catch (e) { setMessage(e.response?.data?.error || e.message); }
    finally { setPending(false); }
  };
  const button = { background: '#222', border: '1px solid #555', borderRadius: 5, color: '#eee',
    padding: '7px 11px', cursor: 'pointer', fontFamily: 'inherit' };
  return <section aria-label="TV sync controls" style={{ border: '1px solid #53420e', padding: 12, marginTop: 14, color: '#ddd', background: '#151515' }}>
    <strong style={{ color: '#f9b000' }}>TV SYNC · {settings.enabled ? 'ON' : 'OFF — LIVE DATA'}</strong>
    <p style={{ margin: '8px 0' }}>Broadcast delay: <b>{(settings.delayMs / 1000).toFixed(0)}s</b> · version {settings.version} · {state.calibration?.kind || 'pending'}</p>
    <p style={{ fontSize: 12 }}>Data earlier decreases the delay; data later increases it. Changes take effect together across all pub screens.</p>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7 }}>
      <button style={button} disabled={pending || settings.delayMs <= 1000} onClick={() => change(settings.delayMs - 1000, settings.enabled)}>Data earlier −1s</button>
      <button style={button} disabled={pending || settings.delayMs >= 120000} onClick={() => change(settings.delayMs + 1000, settings.enabled)}>Data later +1s</button>
      <button style={button} disabled={pending || (completed && !settings.enabled)} onClick={() => change(settings.delayMs, !settings.enabled)}>{settings.enabled ? 'Turn off TV sync / Return to Live' : 'Match pub TV'}</button>
      <button style={button} disabled={pending} onClick={() => { setMessage('Auto recalibration is unavailable: use Data earlier/later to manually re-sync.'); }}>Calibration help</button>
      <button style={button} disabled={pending || completed} onClick={prepare}>Prepare TV sync</button>
    </div>
    <p style={{ fontSize: 12, marginBottom: 0 }}>First lock: {state.calibration?.firstPredictionLockAt || 'not recorded'} · Auto start: {anchors?.autoCalibration ? 'verified' : 'not verified; manual only'}</p>
    {message && <p role="status" style={{ color: '#f9b000' }}>{message}</p>}
  </section>;
}
